export enum StatusFilterBackup {
  Disabled = 0,
  Enabled,
  NotAvailable
}
